var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',[_c('v-progress-circular',{staticStyle:{"position":"fixed","bottom":"50%","top":"50%"},attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }